module.exports = __webpack_public_path__ + "static/media/dollars_sm.6fca3522.jpg";